import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { ConfirmButton } from 'components/common';

const CertificatesDelete = connect((state) => state)(
  class extends Component {
    delete = async () => {
      const { templateId, updateTemplates } = this.props;
      const response = await api.delete(
        `/admin/certificate-templates/${templateId}`
      );
      if (!response.data || !response.data.success) return false;
      await updateTemplates();
      return true;
    };

    render() {
      const { messages } = this.props;

      return (
        <ConfirmButton
          actionText={messages.commonDelete}
          buttonIcon="trash-alt"
          buttonText={messages.commonDelete}
          category="danger"
          confirmText={messages.siteCertificatesDeleteConfirm}
          confirmTitle={messages.siteCertificatesDelete}
          onConfirm={this.delete}
          successMessage={messages.siteCertificatesDeleteSuccess}
          stopPropagation={true}
        />
      );
    }
  }
);

export default CertificatesDelete;
